import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Link,
  IconButton,
  ListItem,
  Stack,
  Typography,
  ListItemText,
} from '@mui/material';
import AppConstants from '../../constants/AppConstants';
import { Image as ImageIcon } from 'react-feather';
import { DragSource } from 'react-dnd';

const workoutSource = {
  beginDrag: function (props) {
    // this get used by squareTarget#drop as monitor.getItem()
    return props;
  },
};

const collect = function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
};

class TrainingPlanWorkoutListItem extends React.Component {
  render() {
    const connectDragSource = this.props.connectDragSource;
    const isDragging = this.props.isDragging;
    const workout = this.props.workout; // this is actually the "event", the workout id is workout.objectId

    if (!workout) {
      return <div />;
    }

    const eventId = workout._id ?? workout.objectId ?? workout.title;
    const workoutId = workout.objectId ?? workout._id;

    if (this.props.children) {
      return connectDragSource(
        <div style={{ opacity: isDragging ? 0.5 : 1, cursor: 'move' }}>
          {this.props.children}
        </div>
      );
    }

    if (this.props.variant === 'schedule') {
      const meta = this.props.meta ?? ['45 min', '8 exercises'];
      const display = (
        <Box
          sx={{
            opacity: isDragging ? 0.5 : 1,
            cursor: 'move',
            position: 'relative',
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            {this.props.icon}
            <Link
              href={`/trainer/workouts/${workoutId}`}
              target="_blank"
              underline="none"
              sx={{ color: '#0f1d2d', minWidth: 0 }}
            >
              <Typography noWrap sx={{ fontWeight: 800, fontSize: 14 }}>
                {workout.title}
              </Typography>
            </Link>
          </Stack>
          <Typography sx={{ color: '#506176', fontSize: 13, mt: 1 }}>
            {meta[0]}
          </Typography>
          <Typography sx={{ color: '#506176', fontSize: 13 }}>
            {meta[1]}
          </Typography>
          {!!this.props.onRemove && (
            <IconButton
              size="small"
              aria-label="remove"
              onClick={(e) => {
                e.preventDefault();
                this.props.onRemove(workout);
              }}
              sx={{ position: 'absolute', right: 0, bottom: -4 }}
            >
              ×
            </IconButton>
          )}
        </Box>
      );

      return connectDragSource(
        <div style={{ opacity: isDragging ? 0.5 : 1, cursor: 'move' }}>
          {display}
        </div>
      );
    }

    let media;
    if (workout.coverImageUrl) {
      media = (
        <img
          alt="Workout"
          src={workout.coverImageUrl}
          style={{ width: 20, height: 20, margin: 3, verticalAlign: 'middle' }}
        />
      );
    } else {
      media = <ImageIcon size={20} />;
    }

    const display = (
      <div key={eventId}>
        {' '}
        <ListItem
          sx={{
            position: 'relative',
            cursor: 'move',
            opacity: isDragging ? 0.5 : 1,
            backgroundColor: '#f4f6f8',
          }}
          disableGutters
          secondaryAction={
            !!this.props.onRemove && (
              <IconButton
                size="small"
                edge="end"
                aria-label="remove"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.onRemove(workout);
                }}
              >
                ×
              </IconButton>
            )
          }
        >
          <Link href={`/trainer/workouts/${workoutId}`} target="_blank">
            <ListItemText
              primary={
                <Typography variant="caption">
                  {media}
                  {workout.title}
                </Typography>
              }
            />
          </Link>
        </ListItem>
      </div>
    );

    return connectDragSource(display);
  }
}

TrainingPlanWorkoutListItem.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
};

export default DragSource(
  AppConstants.WORKOUT,
  workoutSource,
  collect
)(TrainingPlanWorkoutListItem);
